/**
 * Product SEO copy helpers
 * Extends window.WorkshopBookingWizardHelpers (defer after helpers.js).
 */
(function (global) {
  'use strict';
  var H = global.WorkshopBookingWizardHelpers;
  if (!H) return;

  var CITY_DESC_LEAD_CLASS = 'wbw-city-desc-lead';
  var CITY_DESC_ANCHOR_PATTERN = /inspired patterns/i;

  function normalizeWorkshopLabel(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isNodeAfter(anchor, node) {
    if (!anchor || !node) return false;
    return !!(anchor.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function findWorkshopEyebrow(rte, baseTitle) {
    if (!rte) return null;
    var marked = rte.querySelector('[data-wbw-base-eyebrow]');
    if (marked) return marked;
    var baseNorm = normalizeWorkshopLabel(baseTitle);
    if (!baseNorm) return null;
    var nodes = rte.querySelectorAll('p, span, strong, em, label, h2, h3, h4, h5, h6');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var norm = normalizeWorkshopLabel(el.textContent);
      if (!norm || norm.length > 120) continue;
      if (norm === baseNorm) return el;
      if (
        baseNorm.length >= 10 &&
        norm.length >= 10 &&
        (norm.indexOf(baseNorm) >= 0 || baseNorm.indexOf(norm) >= 0)
      ) {
        return el;
      }
    }
    return null;
  }

  function syncWorkshopEyebrow(rte, baseTitle, city) {
    var el = findWorkshopEyebrow(rte, baseTitle);
    if (!el) return;
    if (!el.dataset.wbwBaseEyebrow) {
      el.dataset.wbwBaseEyebrow = String(el.textContent || '').trim();
    }
    var base = el.dataset.wbwBaseEyebrow;
    el.textContent = city ? base + ' in ' + city : base;
  }

  function findCityDescAnchor(rte, eyebrowEl) {
    if (!rte) return null;
    var paragraphs = rte.querySelectorAll('p');
    for (var i = 0; i < paragraphs.length; i++) {
      var p = paragraphs[i];
      if (p.classList.contains(CITY_DESC_LEAD_CLASS)) continue;
      if (eyebrowEl && !isNodeAfter(eyebrowEl, p)) continue;
      var text = String(p.textContent || '').trim();
      if (text.length < 30) continue;
      if (/what you.ll do/i.test(text)) break;
      if (/^(duration|level|materials|take home)$/i.test(text)) continue;
      return p;
    }
    for (var j = 0; j < paragraphs.length; j++) {
      var legacy = paragraphs[j];
      if (legacy.classList.contains(CITY_DESC_LEAD_CLASS)) continue;
      if (CITY_DESC_ANCHOR_PATTERN.test(String(legacy.textContent || ''))) return legacy;
    }
    for (var k = 0; k < paragraphs.length; k++) {
      var fallback = paragraphs[k];
      if (fallback.classList.contains(CITY_DESC_LEAD_CLASS)) continue;
      if (String(fallback.textContent || '').trim().length >= 50) return fallback;
    }
    return null;
  }

  function placeCityDescLead(rte, lead, anchor) {
    if (!rte || !lead) return;
    if (anchor && anchor.parentNode) {
      if (lead.parentNode !== anchor.parentNode || lead.previousElementSibling !== anchor) {
        anchor.parentNode.insertBefore(lead, anchor.nextSibling);
      }
      return;
    }
    if (lead.parentNode !== rte) {
      rte.appendChild(lead);
    }
  }

  function buildVenueSeoTitle(baseTitle, city) {
    var base = String(baseTitle || '').replace(/\s+/g, ' ').trim();
    var loc = String(city || '').replace(/\s+/g, ' ').trim();
    if (!base) return loc;
    if (!loc) return base;
    if (base.toLowerCase().indexOf(loc.toLowerCase()) >= 0) return base;
    return base + ' in ' + loc;
  }

  function buildVenueSeoDescription(city, dateLabel) {
    var loc = String(city || '').replace(/\s+/g, ' ').trim();
    if (!loc) return '';
    var text = 'Join us in ' + loc + ' for this hands-on workshop experience.';
    var when = String(dateLabel || '').replace(/\s+/g, ' ').trim();
    if (when) text += ' Available on ' + when + '.';
    return text;
  }

  var seoHeadSnap = null;

  function ensureSeoHeadSnapshot() {
    if (seoHeadSnap) return seoHeadSnap;
    var desc = document.querySelector('meta[name="description"]');
    var ogTitle = document.querySelector('meta[property="og:title"]');
    var ogDesc = document.querySelector('meta[property="og:description"]');
    var ogUrl = document.querySelector('meta[property="og:url"]');
    var twTitle = document.querySelector('meta[name="twitter:title"]');
    var twDesc = document.querySelector('meta[name="twitter:description"]');
    var canon = document.querySelector('link[rel="canonical"]');
    seoHeadSnap = {
      title: document.title,
      description: desc ? desc.getAttribute('content') || '' : '',
      ogTitle: ogTitle ? ogTitle.getAttribute('content') || '' : '',
      ogDescription: ogDesc ? ogDesc.getAttribute('content') || '' : '',
      ogUrl: ogUrl ? ogUrl.getAttribute('content') || '' : '',
      twTitle: twTitle ? twTitle.getAttribute('content') || '' : '',
      twDescription: twDesc ? twDesc.getAttribute('content') || '' : '',
      canonical: canon ? canon.getAttribute('href') || '' : '',
    };
    return seoHeadSnap;
  }

  function setMetaContent(selector, value) {
    var el = document.querySelector(selector);
    if (!el || value == null) return;
    el.setAttribute('content', value);
  }

  function bookingSeoCanonicalHref() {
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('wbw_step');
      u.searchParams.delete('variant');
      var keep = new URLSearchParams();
      var venue = (u.searchParams.get('venue') || '').trim();
      var eventId = (u.searchParams.get('event_id') || '').trim();
      var stateCode = (u.searchParams.get('state') || u.searchParams.get('state_code') || '').trim();
      if (venue) keep.set('venue', venue);
      if (eventId) keep.set('event_id', eventId);
      if (stateCode) keep.set('state', stateCode);
      var qs = keep.toString();
      return u.origin + u.pathname + (qs ? '?' + qs : '');
    } catch (_) {
      return window.location.origin + window.location.pathname;
    }
  }

  function shopTitleSuffix(fullTitle) {
    var t = String(fullTitle || '');
    var cut = t.lastIndexOf(' – ');
    if (cut < 0) cut = t.lastIndexOf(' | ');
    return cut >= 0 ? t.slice(cut) : '';
  }

  function syncBookingSeoHead(opts) {
    opts = opts || {};
    var snap = ensureSeoHeadSnapshot();
    var city = String(opts.city || '').trim();
    if (!city) {
      restoreBookingSeoHead();
      return;
    }
    var pageTitle = String(opts.title || '').trim() || snap.title;
    var desc = String(opts.description || '').trim();
    var suffix = shopTitleSuffix(snap.title);
    if (suffix && pageTitle.indexOf(suffix.trim()) < 0) pageTitle = pageTitle + suffix;
    document.title = pageTitle;
    if (desc) {
      var metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', desc);
      setMetaContent('meta[property="og:description"]', desc);
      setMetaContent('meta[name="twitter:description"]', desc);
    }
    setMetaContent('meta[property="og:title"]', pageTitle);
    setMetaContent('meta[name="twitter:title"]', pageTitle);
    var canonHref = bookingSeoCanonicalHref();
    var canon = document.querySelector('link[rel="canonical"]');
    if (canon) canon.setAttribute('href', canonHref);
    setMetaContent('meta[property="og:url"]', canonHref);
  }

  function restoreBookingSeoHead() {
    if (!seoHeadSnap) return;
    document.title = seoHeadSnap.title;
    setMetaContent('meta[name="description"]', seoHeadSnap.description);
    setMetaContent('meta[property="og:title"]', seoHeadSnap.ogTitle);
    setMetaContent('meta[property="og:description"]', seoHeadSnap.ogDescription);
    setMetaContent('meta[property="og:url"]', seoHeadSnap.ogUrl);
    setMetaContent('meta[name="twitter:title"]', seoHeadSnap.twTitle);
    setMetaContent('meta[name="twitter:description"]', seoHeadSnap.twDescription);
    var canon = document.querySelector('link[rel="canonical"]');
    if (canon && seoHeadSnap.canonical) canon.setAttribute('href', seoHeadSnap.canonical);
  }

  function bookingJsonLdEl() {
    return document.getElementById('wbw-event-jsonld');
  }

  function restoreBookingEventJsonLd() {
    var el = bookingJsonLdEl();
    if (!el) return;
    var base = el.getAttribute('data-wbw-ld-base');
    if (base) el.textContent = base;
  }

  function syncBookingEventJsonLd(payload) {
    var el = bookingJsonLdEl();
    if (!el) return;
    if (!el.getAttribute('data-wbw-ld-base')) {
      el.setAttribute('data-wbw-ld-base', el.textContent || '');
    }
    payload = payload || {};
    if (!payload.city || !payload.startDate) {
      restoreBookingEventJsonLd();
      return;
    }
    var data;
    try {
      data = JSON.parse(el.getAttribute('data-wbw-ld-base') || '{}');
    } catch (_) {
      return;
    }
    var graph = Array.isArray(data['@graph']) ? data['@graph'].slice() : [];
    var productUrl = window.location.origin + window.location.pathname;
    var selectedId = productUrl + '#event-selected';
    graph = graph.filter(function (node) {
      return !node || node['@id'] !== selectedId;
    });
    var eventNode = {
      '@type': 'Event',
      '@id': selectedId,
      name: String(payload.name || '').trim() || document.title,
      startDate: String(payload.startDate),
      eventStatus: 'https://schema.org/EventScheduled',
      eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
      url: bookingSeoCanonicalHref(),
    };
    if (payload.endDate) eventNode.endDate = String(payload.endDate);
    if (payload.description) eventNode.description = String(payload.description);
    if (payload.city) {
      eventNode.location = {
        '@type': 'Place',
        name: String(payload.venueName || payload.city),
        address: {
          '@type': 'PostalAddress',
          addressLocality: String(payload.city),
        },
      };
    }
    graph.push(eventNode);
    data['@context'] = data['@context'] || 'https://schema.org';
    data['@graph'] = graph;
    try {
      el.textContent = JSON.stringify(data);
    } catch (_) {}
  }

  function fitProductSeoH1(el, hasCity) {
    if (!el) return;
    el.style.whiteSpace = '';
    el.style.fontSize = '';
    el.style.letterSpacing = '';
    el.classList.toggle('wbw-seo-h1', !!hasCity);
    if (!hasCity) return;
    el.style.letterSpacing = '-0.02em';
    el.style.whiteSpace = 'nowrap';
    var maxPx = parseFloat(window.getComputedStyle(el).fontSize) || 28;
    var minPx = 17;
    if (el.scrollWidth <= el.clientWidth + 1) return;
    var lo = minPx;
    var hi = maxPx;
    var best = minPx;
    while (hi - lo > 0.4) {
      var mid = (lo + hi) / 2;
      el.style.fontSize = mid + 'px';
      if (el.scrollWidth <= el.clientWidth + 1) {
        best = mid;
        lo = mid;
      } else {
        hi = mid;
      }
    }
    el.style.fontSize = best + 'px';
    if (best <= minPx + 0.2 && el.scrollWidth > el.clientWidth + 1) {
      el.style.whiteSpace = 'normal';
      el.style.fontSize = '';
    }
  }

  H.CITY_DESC_LEAD_CLASS = CITY_DESC_LEAD_CLASS;
  H.CITY_DESC_ANCHOR_PATTERN = CITY_DESC_ANCHOR_PATTERN;
  H.normalizeWorkshopLabel = normalizeWorkshopLabel;
  H.isNodeAfter = isNodeAfter;
  H.findWorkshopEyebrow = findWorkshopEyebrow;
  H.syncWorkshopEyebrow = syncWorkshopEyebrow;
  H.findCityDescAnchor = findCityDescAnchor;
  H.placeCityDescLead = placeCityDescLead;
  H.buildVenueSeoTitle = buildVenueSeoTitle;
  H.buildVenueSeoDescription = buildVenueSeoDescription;
  H.syncBookingSeoHead = syncBookingSeoHead;
  H.restoreBookingSeoHead = restoreBookingSeoHead;
  H.syncBookingEventJsonLd = syncBookingEventJsonLd;
  H.restoreBookingEventJsonLd = restoreBookingEventJsonLd;
  H.bookingSeoCanonicalHref = bookingSeoCanonicalHref;
  H.fitProductSeoH1 = fitProductSeoH1;

  global.WorkshopBookingWizardSeo = {
    CITY_DESC_LEAD_CLASS: CITY_DESC_LEAD_CLASS,
    normalizeWorkshopLabel: normalizeWorkshopLabel,
    isNodeAfter: isNodeAfter,
    findWorkshopEyebrow: findWorkshopEyebrow,
    syncWorkshopEyebrow: syncWorkshopEyebrow,
    findCityDescAnchor: findCityDescAnchor,
    placeCityDescLead: placeCityDescLead,
    buildVenueSeoTitle: buildVenueSeoTitle,
    buildVenueSeoDescription: buildVenueSeoDescription,
    syncBookingSeoHead: syncBookingSeoHead,
    restoreBookingSeoHead: restoreBookingSeoHead,
    syncBookingEventJsonLd: syncBookingEventJsonLd,
    restoreBookingEventJsonLd: restoreBookingEventJsonLd,
    bookingSeoCanonicalHref: bookingSeoCanonicalHref,
    fitProductSeoH1: fitProductSeoH1
  };
})(typeof window !== "undefined" ? window : this);
